import React from "react";
import {
  Box,
  Typography,
  ToggleButtonGroup,
  ToggleButton,
} from "@mui/material";

const GiftPackagingSelector = ({ giftPackaging, setGiftPackaging }) => {
  const handleChange = (_, newValue) => {
    if (newValue === "yes") setGiftPackaging(true);
    else if (newValue === "no") setGiftPackaging(false);
  };

  return (
    <Box sx={{ mt: 4, mb: 3 }}>
      <Typography fontWeight="bold" sx={{ mb: 1 }}>
        Gift Packaging: {giftPackaging ? "Yes" : "No"}
      </Typography>
      <ToggleButtonGroup
        value={giftPackaging ? "yes" : "no"}
        exclusive
        onChange={handleChange}
        sx={{ flexWrap: "wrap" }}>
        <ToggleButton
          value="no"
          sx={{
            textTransform: "capitalize",
            minWidth: 120,
            flexDirection: "column",
            alignItems: "center",
          }}>
          No
        </ToggleButton>
        <ToggleButton
          value="yes"
          sx={{
            textTransform: "capitalize",
            minWidth: 120,
            flexDirection: "column",
            alignItems: "center",
          }}>
          <Box>Yes</Box>
          <Typography variant="caption" color="text.secondary">
            +$3.00
          </Typography>
        </ToggleButton>
      </ToggleButtonGroup>
    </Box>
  );
};

export default GiftPackagingSelector;
